import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PUBLIC_ROUTES } from './public.routes';
import { ServicesModule } from 'src/app/services/services.module';
import { PublicComponent } from './public.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { SharedModule } from '../../components/shared/shared.module';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { DirectivesModule } from '../../directives/directives.module';
import { ValidationsModule } from '../../validators/validations.module';
import { ValidationModule } from 'src/app/components/validation/shared.module';

const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  imports: [
    PUBLIC_ROUTES,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ServicesModule,
    DirectivesModule,
    ValidationsModule,
    NgxMaskModule.forRoot(maskConfig),
    SharedModule,
    ValidationModule,
  ],
  declarations: [PublicComponent, LoginComponent, ForgotPasswordComponent, PasswordResetComponent, ConfirmEmailComponent],
})
export class PublicModule {}
